import{__assign as t}from"../_virtual/_tslib.js";import r,{forwardRef as e}from"react";import{ButtonRoundedBase as o}from"./ButtonRoundedBase.js";var m=e((function(e,m){return r.createElement(o,t({},e,{ref:m}))}));m.displayName="ButtonRounded";export{m as ButtonRounded};
//# sourceMappingURL=ButtonRounded.js.map
